import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { AppProvider, Tabs } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';
import './styles/jitsu-theme.css';

import HomePage from './pages/HomePage';
import FulfillmentsPage from './pages/FulfillmentsPage';
import SettingsPage from './pages/SettingsPage';
import ToolsPage from './pages/ToolsPage';
import EventLogPage from './pages/EventLogPage';

const tabs = [
  { id: 'home', content: 'Dashboard', path: '/' },
  { id: 'fulfillments', content: 'Shipping Center', path: '/fulfillments' },
  { id: 'settings', content: 'Settings', path: '/settings' },
  { id: 'tools', content: 'Tools', path: '/tools' },
  { id: 'events', content: 'Event Log', path: '/events' },
];

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();

  const selectedTabIndex = tabs.findIndex(tab => tab.path === location.pathname);

  const handleTabChange = (selectedIndex: number) => {
    navigate(tabs[selectedIndex].path);
  };

  return (
    <AppProvider i18n={enTranslations}>
      <div style={{ minHeight: '100vh', backgroundColor: '#F2F2F1' }}>
        {/* Jitsu Header */}
        <div className="jitsu-header">
          <img src="/images/logo-jitsu.svg" alt="Jitsu" />
          <h1>Ship with Jitsu</h1>
        </div>

        {/* Navigation Tabs */}
        <div style={{ padding: '0 20px' }}>
          <Tabs
            tabs={tabs.map(tab => ({ id: tab.id, content: tab.content }))}
            selected={selectedTabIndex >= 0 ? selectedTabIndex : 0}
            onSelect={handleTabChange}
          />
        </div>

        {/* Main Content */}
        <div style={{ padding: '20px' }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/fulfillments" element={<FulfillmentsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/events" element={<EventLogPage />} />
          </Routes>
        </div>
      </div>
    </AppProvider>
  );
}

